import React, { useEffect, useState } from 'react';

import { Button } from '@/components/ui/button';
import TextAreaField from '@/components/atoms/TextAreaField';
import workActivityRejectIcon from '@/assets/icons/work-activity-reject.svg';

interface WorkActivityRejectModalProps {
  isOpen: boolean;
  onConfirm: (rejectionNote: string) => void;
  onClose: () => void;
  loading?: boolean;
}

const WorkActivityRejectModal: React.FC<WorkActivityRejectModalProps> = ({
  isOpen,
  onConfirm,
  onClose,
  loading = false
}) => {
  const [rejectionNote, setRejectionNote] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setRejectionNote('');
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed w-screen h-screen top-0 left-0 bg-[rgba(82,80,96,0.5)] backdrop-blur-[8px] z-50 flex items-center justify-center">
      <div className="bg-white rounded-[16px] overflow-hidden w-[327px]">
        <div className="w-full py-7 px-7 md:p-0 flex flex-col items-center justify-center gap-2">
          <div className="md:bg-secondary w-full md:mb-4 md:py-10 flex items-center justify-center">
            <img
              className="w-[60px] h-[60px] md:w-auto md:h-auto mb-3 mx-auto"
              src={workActivityRejectIcon}
              alt="reject-work-activity-icon"
            />
          </div>
          <p className="md:px-7 font-bold text-xl text-center leading-[24.3px] md:mb-[0.15rem]">
            Are you sure want to reject this work activity?
          </p>
          <p className="md:px-7 text-sm text-secondary text-center leading-[17px]">
            Leave a rejection note for the employee
          </p>
        </div>

        <div className="px-5 pb-2 mt-2">
          <TextAreaField
            name="rejection_note"
            value={rejectionNote}
            onChange={(event) => setRejectionNote(event.target.value)}
            placeholder="rejection notes"
            rows={4}
          />
        </div>

        <div className="flex md:gap-4 md:px-5 md:mb-6 md:mt-7">
          <Button
            type="button"
            onClick={onClose}
            className="w-full text-base font-semibold !rounded-none h-[52px] md:w-full md:text-[1rem] md:font-semibold md:!rounded-full md:h-[44px]"
            variant="primary-reverse"
            disabled={loading}
          >
            Cancel
          </Button>

          <Button
            type="button"
            onClick={() => onConfirm(rejectionNote.trim())}
            className="w-full text-base font-semibold !rounded-none h-[52px] md:w-full md:text-[1rem] md:font-semibold md:!rounded-full md:h-[44px]"
            variant="default"
            disabled={loading || !rejectionNote.trim()}
          >
            {loading ? 'Rejecting...' : 'Reject'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WorkActivityRejectModal;
